import { render, staticRenderFns } from "./approval-detail.vue?vue&type=template&id=122d5256&scoped=true"
import script from "./approval-detail.vue?vue&type=script&lang=js"
export * from "./approval-detail.vue?vue&type=script&lang=js"
import style0 from "./approval-detail.vue?vue&type=style&index=0&id=122d5256&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122d5256",
  null
  
)

export default component.exports